/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useRef} from "react";

export const useDidUpdate = (fn: VoidFunction | VoidFunction, conditions: any[]) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      // Cleanup effects when fn returns a function
      return fn && fn();
    }
  }, conditions);

  // Track real mount/unmount in a dedicated effect.
  useEffect(() => {
    didMountRef.current = true;
    return () => {
      didMountRef.current = false;
    };
  }, []);
};
